(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultDetailController', PhoneCallResultDetailController);

    /* Added UIFormAccess
    PhoneCallResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResult', 'PhoneCallResultGroup'];

    function PhoneCallResultDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResult, PhoneCallResultGroup) {
    */
    PhoneCallResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResult', 'PhoneCallResultGroup', 'UIFormAccess'];

    function PhoneCallResultDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResult, PhoneCallResultGroup, UIFormAccess) {
        var vm = this;

        vm.phoneCallResult = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallResultUpdate', function(event, result) {
            vm.phoneCallResult = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
